import { render, staticRenderFns } from "./CustomerShowOrthoIpr.vue?vue&type=template&id=514dc91d"
import script from "./CustomerShowOrthoIpr.vue?vue&type=script&lang=js"
export * from "./CustomerShowOrthoIpr.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowOrthoIpr.vue?vue&type=style&index=0&id=514dc91d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports